/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { authzSetting } from '../models/authzSetting';
import type { parametersFilter } from '../models/parametersFilter';
import type { parametersFilterCount } from '../models/parametersFilterCount';
import type { parametersFilterDelete } from '../models/parametersFilterDelete';
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AuthzSettingsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * count authzSettings
   * Count authzSettings (with filtering, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any Count of authzSetting documents found. Wrapped in a JsonAPI root response with wrapped count result as data.
   * @throws ApiError
   */
  public getApiServiceauthorizationAuthzSettingsCount(
    filter?: parametersFilterCount,
  ): CancelablePromise<{
    data?: {
      count?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceauthorization/authzSettings/count',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find one authzSetting
   * Find one authzSetting by its unique identifier.
   * @param identifier authzSetting unique identifier
   * @returns any One authzSetting document found. Wrapped in a JsonAPI root response with document as data.
   * @throws ApiError
   */
  public getApiServiceauthorizationAuthzSettings(
    identifier: string,
  ): CancelablePromise<{
    data?: authzSetting;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceauthorization/authzSettings/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update one existing authzSetting
   * Partially update one existing authzSetting
   * @param identifier authzSetting unique identifier
   * @param requestBody
   * @returns any updated authzSetting. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServiceauthorizationAuthzSettings(
    identifier: string,
    requestBody?: authzSetting,
  ): CancelablePromise<{
    data?: authzSetting;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceauthorization/authzSettings/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete one authzSetting
   * Delete one authzSetting
   * @param identifier authzSetting unique identifier
   * @returns any delete status authzSettings. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServiceauthorizationAuthzSettings(
    identifier: string,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceauthorization/authzSettings/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find many authzSettings
   * Find many authzSettings (with filtering, projection, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * - To only return specific fields, use the projection query parameter. Usage is as follows: filter[fields][fieldName1]=true&filter[fields][fieldName2]=true.
   * @param filter
   * @returns any One or many authzSetting documents found. Wrapped in a JsonAPI root response with collection of documents as data.
   * @throws ApiError
   */
  public getApiServiceauthorizationAuthzSettings1(
    filter?: parametersFilter,
  ): CancelablePromise<{
    data?: Array<authzSetting>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceauthorization/authzSettings',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * create one or multiple authzSettings
   * Create one or multiple authzSettings
   * @param requestBody
   * @returns any One or many authzSetting documents created. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public postApiServiceauthorizationAuthzSettings(
    requestBody?: (authzSetting | Array<authzSetting>),
  ): CancelablePromise<{
    data?: (authzSetting | Array<authzSetting>);
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceauthorization/authzSettings',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update many existing authzSetting
   * Partially update many existing authzSetting
   * @param requestBody
   * @returns any authzSettings updated. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServiceauthorizationAuthzSettings1(
    requestBody?: Array<authzSetting>,
  ): CancelablePromise<{
    data?: Array<authzSetting>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceauthorization/authzSettings',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete many authzSettings
   * Delete many authzSettings using filtering. You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any delete status authzSettings. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServiceauthorizationAuthzSettings1(
    filter?: parametersFilterDelete,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceauthorization/authzSettings',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

}
